/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import Modal from '/client/src/components/Modal';
import Switcher from '/client/src/components/switcher';
import { PUT } from '/client/src/api';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import CssPinner from '/client/src/components/csspinner';
import NProgressCustom from '/client/src/components/nProgress';
import './styles.scss';

type PropsType = {
  isOpen: boolean,
  handleShowtableViewModal: (boolean) => void,
  handleTriggerChangeTableContent: () => void,
  setRowsFilter: (string) => void,
  rowsFilter: { [any]: boolean }
};

type StateType = {
  checkboxes: any
};

class EventPageDetailCustomersModal extends React.Component<PropsType, StateType> {
  static contextType = DefaultContainerContext;

  state = {
    checkboxes: [
      {
        id: 'Attendance_Count',
        label: 'Attendance Count',
        checked: false,
        type: 'c26'
      },
      {
        id: 'Ticket_Type',
        label: 'Ticket Type',
        checked: false,
        type: 'c7'
      },
      {
        id: 'Email',
        label: 'Email',
        checked: false,
        type: 'c5'
      },
      {
        id: 'Phone',
        label: 'Phone',
        checked: false,
        type: 'c6'
      },
      {
        id: 'Notes',
        label: 'Notes',
        checked: false,
        type: 'c8'
      },
      {
        id: 'Date_Purchased',
        label: 'Date Purchased',
        checked: false,
        type: 'c4'
      },
      {
        id: 'Payout',
        label: 'Payout',
        checked: false,
        type: 'c15'
      },
      {
        id: 'Purchaser',
        label: 'Purchaser',
        checked: false,
        type: 'c1'
      },
      {
        id: 'Ticket_Price',
        label: 'Ticket Price',
        checked: false,
        type: 'c9'
      },
      {
        id: 'Payment_Currency',
        label: 'Payment Currency',
        checked: false,
        type: 'c10'
      },
      {
        id: 'Promo_Discount',
        label: 'Discount Amount',
        checked: false,
        type: 'c11'
      },
      {
        id: 'Tax',
        label: 'Tax',
        checked: false,
        type: 'c12'
      },
      {
        id: 'Your_Unit_Service_Fee',
        label: 'Your Unit Service Fee',
        checked: false,
        type: 'c13'
      },
      {
        id: 'Sparxo_and_CC_Processing',
        label: 'Sparxo and CC Processing',
        checked: false,
        type: 'c14'
      },
      {
        id: 'Fee_Type',
        label: 'Fee Type',
        checked: false,
        type: 'c24'
      },
      {
        id: 'Ticket_Code',
        label: 'Ticket Code',
        checked: false,
        type: 'c16'
      },
      {
        id: 'Last_4_cc',
        label: 'Last 4 cc',
        checked: false,
        type: 'c17'
      },
      {
        id: 'Referred_By',
        label: 'Referred By',
        checked: false,
        type: 'c18'
      },
      {
        id: 'Discount_Code',
        label: 'Discount Code',
        checked: false,
        type: 'c19'
      },
      {
        id: 'Payment_Status',
        label: 'Payment Status',
        checked: false,
        type: 'c20'
      },
      {
        id: 'Ticket_Status',
        label: 'Ticket Status',
        checked: false,
        type: 'c21'
      },
      {
        id: 'Check-in_Status',
        label: 'Check-in Status',
        checked: false,
        type: 'c25'
      },
      {
        id: 'Refunded',
        label: 'Refunded',
        checked: false,
        type: 'c22'
      },
      {
        id: 'Update_Time',
        label: 'Update Time',
        checked: false,
        type: 'c23'
      },
      {
        id: 'Sponsors',
        label: 'Sponsors',
        checked: false,
        type: 'c27'
      },
      {
        id: 'QR_Code',
        label: 'QR Code',
        checked: false,
        type: 'c28'
      }
    ]
  };

  handleClose = (): any => {
    const { handleShowtableViewModal } = this.props;

    handleShowtableViewModal(false);
  };

  handleChangeCheckbox = (e: SyntheticEvent<HTMLInputElement>) => {
    const value = e.target.checked;
    const index = e.target.dataset.index;
    const _checkboxes = [
      ...this.state.checkboxes
    ];

    _checkboxes[index].checked = value;

    this.setState({
      checkboxes: _checkboxes
    });
  };

  handleSave = async () => {
    const dataForRequest = {};
    const { checkboxes } = this.state;

    _.forEach(checkboxes, (item: {}) => {
      dataForRequest[item.type] = item.checked;
    });
    const modalNode = document.querySelector('.Modal__inner');

    try {
      CssPinner(modalNode, true);
      NProgressCustom(true);

      await PUT('/api/v1/1/merchants/attendee_field_filter', {
        filter_config: JSON.stringify(dataForRequest)
      });

      this.props.setRowsFilter(dataForRequest);

      this.props.handleTriggerChangeTableContent();

      CssPinner(modalNode, false);
      NProgressCustom(false);
      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'success',
        systemDialogTitle: 'Great!',
        systemDialogContent: 'Successfully saved'
      });

      this.handleClose();
    } catch (e) {
      CssPinner(modalNode, false);
      NProgressCustom(false);
      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: 'Can\'t save filters'
      });
    }
  }

  item = (option: [], index: number): React.Element<'div'> => {
    return (
      <div className="col-xs-6" key={option.id}>
        <div className="filter-item">
          <Switcher
            className='form-switcher-sm pull-left'
            id={option.id}
            index={index}
            checked={option.checked}
            onCallback={this.handleChangeCheckbox}
            label={option.label}
          />
        </div>
      </div>
    );
  }
  setCheckboxes = () => {
    const cloneCheckbox = _.clone(this.state.checkboxes);

    _.map(cloneCheckbox, (el: any, index: number) => {
      const stateCheckbox = this.props.rowsFilter[el.type];

      if (!!stateCheckbox) {
        cloneCheckbox[index].checked = stateCheckbox;
      }
    });

    this.setState({ checkboxes: cloneCheckbox });
  }
  componentDidMount() {
    this.setCheckboxes();
  }
  componentDidUpdate(prevProps: PropsType) {
    if (prevProps.rowsFilter !== this.props.rowsFilter) {
      this.setCheckboxes();
    }
  }

  render(): React.Element {
    const { isOpen } = this.props;
    const { checkboxes } = this.state;

    return (
      <Modal
        opened={isOpen}
        onClose={this.handleClose}
        altView
        isScrollable
      >
        <div className="modal-dialog customModal EventPageDetailCustomersModal modal-table-filter" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <span className="icon icon-cogs modal-icon modal-icon-gary" style={{ marginRight: '2rem' }} />
                <span>Ticket Table Filter</span>
              </h4>
            </div>
            <div className="modal-body" style={{ padding: '2rem 0 1rem' }}>

              <div className="container-fluid">
                {_.map(checkboxes, (chi: {}, chk: number): React.Element<'div'> => this.item(chi, chk))}
              </div>

            </div>
            <div className="modal-footer">
              <button className="btn btn-gray" onClick={this.handleClose}>Close</button>
              <button
                className="btn btn-pink"
                onClick={this.handleSave}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EventPageDetailCustomersModal;
